// extracted by mini-css-extract-plugin
export var checkbox = "_35-0";
export var circle = "_35-3";
export var horizontalContainer = "_35-7";
export var sm = "_35-5";
export var switch0 = "_35-2";
export var switchDisabled = "_35-8";
export var switchEnabled = "_35-1";
export var textSwitchContainer = "_35-9";
export var textSwitchOption = "_35-a";
export var textSwitchOptionSelected = "_35-b";
export var verticalContainer = "_35-6";
export var xs = "_35-4";